/**
 * Register the network-only LGL Portal worker so Chrome can offer Install.
 * Does not cache portal bundles.
 */
export const registerFieldServiceWorker = () => {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return;
  navigator.serviceWorker.register('/field-progress-sw.js').catch(() => {});
};
